export const isPwaUser = () => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
  const isMinimalUi = window.matchMedia('(display-mode: minimal-ui)').matches;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const isIosPwa = (window.navigator as any).standalone === true;

  return isStandalone || isFullscreen || isMinimalUi || isIosPwa;
};
